import type { FaireProductEntity } from "../../entity_types/product";

export const p_z5apxep489: FaireProductEntity = {
  token: "p_z5apxep489",
  type: "product",
  name: "LM-SW-1007 Bubblegum/White Puff",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/9c46218958a2a345f5a6f1ad48542cf22e9ca7e10f0ad76827c806fe5a50af79.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.5,
  description: "This graphic sweatshirt from Girlie Girl Originals features a bubblegum and white puff design. Tailored for wear, it offers comfortable fit and bold graphic style that complements a range of looks. The silhouette and bold graphic make it a choice for retailers and personal expression.",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:38.840Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
